import React from 'react';

import { colors } from '../theme/axiom-theme';

export type cssValue = string | false | undefined | null;

/*
  Longest name first: several palette keys prefix others (`panelLight` / `panelLightBlue`), and
  regex alternation takes the first match. The `g` flag covers a value naming two colors.
*/
const COLOR_NAME_PATTERN = new RegExp(
  Object.keys(colors)
    .sort((left, right) => right.length - left.length)
    .join('|'),
  'g'
);

export const AttrsHelper = {
  loremIpsum() {
    return 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Volutpat commodo sed egestas egestas fringilla phasellus faucibus scelerisque eleifend. Sollicitudin nibh sit amet commodo. Imperdiet massa tincidunt nunc pulvinar sapien et. Quam vulputate dignissim suspendisse in est ante in nibh mauris. Ac tincidunt vitae semper quis. Ut tellus elementum sagittis vitae et leo duis ut. In hac habitasse platea dictumst vestibulum rhoncus. Gravida quis blandit turpis cursus in hac habitasse platea. Id donec ultrices tincidunt arcu. Eu feugiat pretium nibh ipsum consequat nisl vel pretium. Eu scelerisque felis imperdiet proin. Sit amet est placerat in egestas. Iaculis nunc sed augue lacus viverra. Commodo quis imperdiet massa tincidunt nunc. Elit duis tristique sollicitudin nibh sit. Ornare massa eget egestas purus viverra accumsan. Volutpat odio facilisis mauris sit amet massa vitae tortor. Nisi vitae suscipit tellus mauris a diam maecenas sed enim.';
  },
  childrenLoremIpsum(paragraphs = 1) {
    return (
      <>
        {Array.from(
          { length: paragraphs },
          (_, index) => `lorem-ipsum-${index}`
        ).map(key => (
          <p key={key}>{AttrsHelper.loremIpsum()}</p>
        ))}
      </>
    );
  },
  formatClassname(...className: unknown[]) {
    return [...new Set(className.filter(Boolean))].join(' ');
  },
  sanitizeCssValue(cssString?: cssValue) {
    return (
      (typeof cssString === 'string' ? cssString.trim() : cssString) ||
      undefined
    );
  },
  replaceColorNameWithHex(cssString?: cssValue) {
    return AttrsHelper.sanitizeCssValue(cssString)?.replace(
      COLOR_NAME_PATTERN,
      colorName => colors[colorName as keyof typeof colors].toLowerCase()
    );
  },
};
